/**
 * Mega Menu Custom Slider
 * Initializes Flickity sliders for custom metafield images in mega menu product cards
 */

class MegaMenuCustomSlider {
  constructor() {
    this.sliders = [];
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initSliders());
    } else {
      this.initSliders();
    }

    // Also listen for mega menu visibility changes
    document.addEventListener('mega-menu:open', () => {
      setTimeout(() => this.initSliders(), 100);
    });
  }

  initSliders() {
    const sliderElements = document.querySelectorAll('.mega-menu-custom-slider:not(.flickity-enabled)');
    
    sliderElements.forEach(element => {
      // Check if Flickity is available
      if (typeof Flickity !== 'undefined') {
        try {
          // Parse data attributes for flickity options
          let options = {
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            autoPlay: false,
            rightToLeft: document.documentElement.dir === 'rtl',
            adaptiveHeight: false,
            cellAlign: 'center',
            contain: true
          };

          // Try to parse data-flickity attribute if it exists
          const dataFlickity = element.getAttribute('data-flickity');
          if (dataFlickity) {
            try {
              const customOptions = JSON.parse(dataFlickity);
              options = { ...options, ...customOptions };
            } catch (e) {
              console.warn('Invalid flickity options in data-flickity attribute:', e);
            }
          }

          // Initialize Flickity
          const flickity = new Flickity(element, options);
          this.sliders.push(flickity);

          // Add auto-play functionality if needed
          if (options.autoPlay && typeof options.autoPlay === 'number') {
            this.setupAutoPlay(flickity, options.autoPlay);
          }

          console.log('Mega menu custom slider initialized', element);
        } catch (error) {
          console.error('Error initializing mega menu custom slider:', error);
        }
      } else {
        console.warn('Flickity not available for mega menu custom slider');
      }
    });
  }

  setupAutoPlay(flickity, interval) {
    let autoPlayTimer;
    let isPaused = false;

    const startAutoPlay = () => {
      if (isPaused) return;
      autoPlayTimer = setInterval(() => {
        if (!isPaused) {
          flickity.next();
        }
      }, interval);
    };

    const stopAutoPlay = () => {
      clearInterval(autoPlayTimer);
    };

    const pauseAutoPlay = () => {
      isPaused = true;
      stopAutoPlay();
    };

    const resumeAutoPlay = () => {
      isPaused = false;
      startAutoPlay();
    };

    // Start auto-play
    startAutoPlay();

    // Pause on hover
    const container = flickity.element.closest('.mega-menu__item');
    if (container) {
      container.addEventListener('mouseenter', pauseAutoPlay);
      container.addEventListener('mouseleave', resumeAutoPlay);
    }

    // Pause when mega menu is closed
    document.addEventListener('mega-menu:close', pauseAutoPlay);
    document.addEventListener('mega-menu:open', resumeAutoPlay);

    // Clean up on destroy
    flickity.on('destroy', () => {
      stopAutoPlay();
    });
  }

  destroy() {
    this.sliders.forEach(slider => {
      if (slider && typeof slider.destroy === 'function') {
        slider.destroy();
      }
    });
    this.sliders = [];
  }
}

// Initialize when script loads
const megaMenuCustomSlider = new MegaMenuCustomSlider();

// Export for potential external use
window.MegaMenuCustomSlider = MegaMenuCustomSlider;
